<template>
  <v-toolbar dark color="teal darken-2">
    <v-toolbar-title class="font-weight-light"
      >ALOHAdmin - {{ this.$route.name }}</v-toolbar-title
    >
    <v-spacer></v-spacer>
    <v-btn active-class="" flat to="/">Accueil</v-btn>
    <v-btn
      active-class=""
      flat
      to="/liste-langues"
      v-if="$keycloak.hasResourceRole('heg-lang', 'aloha-admin-app')"
      >Liste langues</v-btn
    >
    <v-btn
      active-class=""
      flat
      to="/niveau-langue"
      v-if="$keycloak.hasResourceRole('admin', 'aloha-admin-app')"
      >Niveau langue</v-btn
    >
    <!-- <v-btn
      active-class=""
      flat
      to="/notification-center"
      v-if="$keycloak.hasResourceRole('admin', 'aloha-admin-app')"
      >Centre de notification</v-btn
    > -->
    <profile-menu />
  </v-toolbar>
</template>

<script>
import ProfileMenu from './ProfileMenu';
export default {
  components: {
    ProfileMenu,
  },
};
</script>